// Inspired by https://github.com/catdad/canvas-confetti/tree/master.
const confettis = [];
let canvas = null;
let context = null;

let start, previousTimeStamp;

const defaults = {
  particleCount: 50,
  angle: 90,
  spread: 45,
  startVelocity: 55 * 90,
  decay: 0.9,
  gravity: 1.5 * 60,
  drift: 0,
  x: 0.5,
  y: 0.5,
  shapes: ['square', 'circle'],
  zIndex: 1,
  colors: [
    '#26ccff',
    '#a25afd',
    '#ff5e7e',
    '#88ff5a',
    '#fcff42',
    '#ffa62d',
    '#ff36ff'
  ],
  scalar: 1,
  ttl: 3,
};

function randomPhysics(opts) {
  var radAngle = opts.angle * (Math.PI / 180);
  var radSpread = opts.spread * (Math.PI / 180);

  return {
    x: opts.x,
    y: opts.y,
    wobble: Math.random() * 10,
    wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05) * 60,
    velocity: (opts.startVelocity * 0.5) + (Math.random() * opts.startVelocity),
    angle2D: -radAngle + ((0.5 * radSpread) - (Math.random() * radSpread)),
    tiltAngle: (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI,
    color: opts.color,
    shape: opts.shape,
    tick: 0,
    totalTicks: opts.ticks,
    decay: opts.decay,
    drift: opts.drift,
    random: Math.random() + 2,
    tiltSin: 0,
    tiltCos: 0,
    wobbleX: 0,
    wobbleY: 0,
    gravity: opts.gravity * 3,
    ovalScalar: 0.6,
    scalar: opts.scalar,
    elapsedTime: 0,
    ttl: opts.ttl,
  };
}

function animateConfetti(timeStamp) {
  if (start === undefined) {
    start = timeStamp;
    previousTimeStamp = timeStamp;
  }
  const deltaTime = (timeStamp - previousTimeStamp) / 1000;

  context.clearRect(0, 0, canvas.width, canvas.height);

  for (let i = confettis.length -1; i >= 0; i--) {
    const fetti = confettis[i];
    fetti.elapsedTime += deltaTime;

    fetti.velocity *= fetti.decay * Math.max(1 - deltaTime, 0);

    // Update physics.
    fetti.x += Math.cos(fetti.angle2D) * (fetti.velocity * deltaTime) +
      (fetti.drift * deltaTime);

    fetti.y += Math.sin(fetti.angle2D) * (fetti.velocity * deltaTime) +
      (fetti.gravity * deltaTime);

    fetti.wobble += fetti.wobbleSpeed * deltaTime;
    fetti.tiltAngle += 6 * deltaTime;
    fetti.tiltSin = Math.sin(fetti.tiltAngle);
    fetti.tiltCos = Math.cos(fetti.tiltAngle);
    fetti.random = Math.random() + 2;
    fetti.wobbleX = fetti.x + ((10 * fetti.scalar) * Math.cos(fetti.wobble));
    fetti.wobbleY = fetti.y + ((10 * fetti.scalar) * Math.sin(fetti.wobble));

    var progress = (fetti.elapsedTime / fetti.ttl);

    var x1 = fetti.x + (fetti.random * fetti.tiltCos);
    var y1 = fetti.y + (fetti.random * fetti.tiltSin);
    var x2 = fetti.wobbleX + (fetti.random * fetti.tiltCos);
    var y2 = fetti.wobbleY + (fetti.random * fetti.tiltSin);

    context.beginPath();
    context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';

    if (fetti.shape === 'circle') {
      context.ellipse ?
        context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) :
        ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
    } else {
      context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
      context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
      context.lineTo(Math.floor(x2), Math.floor(y2));
      context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
    }

    context.closePath();
    context.fill();


    if (fetti.elapsedTime >= fetti.ttl) {
      // Remove confetti
      confettis.splice(i, 1);
    }
  }

  previousTimeStamp = timeStamp;

  if (confettis.length > 0) {
    requestAnimationFrame(animateConfetti);
  } else {
    reset();
  }
}

function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
  context.save();
  context.translate(x, y);
  context.rotate(rotation);
  context.scale(radiusX, radiusY);
  context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
  context.restore();
}

function confetti (options = {}, root = document.body) {
  canvas = document.createElement('canvas');
  canvas.style.pointerEvents = 'none';
  canvas.width = root.clientWidth;
  canvas.height = root.clientHeight;
  canvas.style.position = 'absolute';
  canvas.style.zIndex = options.zIndex || defaults.zIndex;
  canvas.style.top = '0';
  canvas.style.left = '0';
  root.appendChild(canvas);

  context = canvas.getContext('2d');

  const particleCount = options.particleCount || defaults.particleCount;

  const angle = options.angle || defaults.angle;
  const spread = options.spread || defaults.spread;
  const startVelocity = options.startVelocity || defaults.startVelocity;
  const decay = options.decay || defaults.decay;
  const gravity = options.gravity || defaults.gravity;
  const drift = options.drift || defaults.drift;
  const colors = colorsToRgb(options.colors || defaults.colors);
  const ticks = options.ticks || defaults.ticks;
  const shapes = options.shapes || defaults.shapes;
  const scalar = options.scalar || defaults.scalar;
  const originX = options.x || defaults.x;
  const originY = options.y || defaults.y;
  const ttl = options.ttl || defaults.ttl;

  const startX = originX;
  const startY = originY;

  for (let i = 0; i < particleCount; i++) {
    confettis.push(
      randomPhysics({
        x: startX,
        y: startY,
        angle: angle,
        spread: spread,
        startVelocity: startVelocity,
        color: colors[i % colors.length],
        shape: shapes[randomInt(0, shapes.length)],
        ticks: ticks,
        decay: decay,
        gravity: gravity,
        drift: drift,
        scalar: scalar,
        ttl,
      })
    );
  }

  requestAnimationFrame(animateConfetti);
}

function reset () {
  cancelAnimationFrame(animateConfetti);
  confettis.splice(0, confettis.length);
  previousTimeStamp = undefined;
  start = undefined;
  canvas.remove();
}

confetti.reset = reset;

export default confetti;

function randomInt (min, max) {
  // [min, max)
  return Math.floor(Math.random() * (max - min)) + min;
}

function colorsToRgb (colors) {
  return colors.map(hexToRgb);
}

function hexToRgb (str) {
  var val = String(str).replace(/[^0-9a-f]/gi, '');

  if (val.length < 6) {
      val = val[0]+val[0]+val[1]+val[1]+val[2]+val[2];
  }

  return {
    r: toDecimal(val.substring(0,2)),
    g: toDecimal(val.substring(2,4)),
    b: toDecimal(val.substring(4,6))
  };
}

function toDecimal (str) {
  return parseInt(str, 16);
}